module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/liver_gallbladder-7dcf1c44e34d28be762b5c5a39e6ab90.png";